import * as types from '../constants/actionTypes';
import initialState from './initialState';
import * as list from '../utils/list';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function userReducer(state = initialState.users, action) {
    let newState;

    switch (action.type) {
        case types.CHANGE_WEEKLY_QUOTA_FOR_USER:
            if (action.status === 'success'){
                newState = changeWeeklyQuota(state, action.data.id, action.data.quota);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.CM_LM_LOAD_USERS_FOR_STAFF_OVERVIEW:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    cmlmUsersForStaffOverview: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_ALL_USERS_FOR_USERS_OVERVIEW:
            if(action.status === 'success') {
                newState = Object.assign({}, state, {
                    usersForUsersOverview: action.data,
                    loading: false
                });
            }
            if(action.status === 'failure') {
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_CURRENT_USER:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    currentUser: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_USERS_NO_LONGER_ASSIGNED:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    usersNoLongerAssigned: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_PMS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    pms: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_REGULAR_USERS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    regularUsers: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_SPONSORS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    sponsorUsers: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_USER_BY_ID:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    userByID: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_ALL_USERS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    allUsers: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_USERS_BY_TASK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    usersByTask: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SET_LOADING_FLAG_FOR_USER_STATE:
            return Object.assign({}, state, {
                loading: true
            });

        case types.SYNC_USERS_WITH_LDAP:
            if (action.status == 'starting'){
                newState = Object.assign({}, state, {
                    syncing: true
                });
            }
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    syncing: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    syncing: false
                });
            }
            return newState;

          case types.SYNC_USER_IDS_WITH_AKIRA:
            if (action.status == 'starting'){
              newState = Object.assign({}, state, {
                syncing: true
              });
            }
            if (action.status === 'success'){
              newState = Object.assign({}, state, {
                syncing: false
              });
            }
            if (action.status === 'failure'){
              newState = Object.assign({}, state, {
                error: action.data,
                syncing: false
              });
            }
            return newState;

        case types.SET_SELECTED_USER:
            return Object.assign({}, state, {
                selectedUser: action.user
            });

        default:
            return state;
    }
}

function changeWeeklyQuota (state, userID, quota) {
    let userList = state.usersForUsersOverview;
    let index = list.findIndexByID(userList, userID);

    userList[index].weeklyQuota = quota;

    let newState = Object.assign({}, state, {
        loading: false,
        usersForUsersOverview: userList
    });
    return newState;
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/userReducer.js
 **/